import React from "react";
import PropTypes from "prop-types";
import { CRow, CCol, CCard, CCardBody, CSpinner } from "@coreui/react";
import CIcon from "@coreui/icons-react";
import { cilCalendar } from "@coreui/icons";
import dayjs from "dayjs";
import i18n from "../../../../i18n";

const ProofGallery = ({ proofs, loading, onPhotoClick }) => {
  if (loading) {
    return (
      <div className="text-center p-5">
        <CSpinner color="primary" />
      </div>
    );
  }

  if (proofs.length === 0) {
    return (
      <div className="text-center p-5 text-muted bg-white rounded border">
        <h4>{i18n.t('proof_gallery.no_photos_found', 'Фотографий за выбранный период не найдено')}</h4>
        <p>
          Убедитесь, что ИИ проанализировал видео и экскаватор совершал
          отгрузки.
        </p>
      </div>
    );
  }

  return (
    <CRow className="g-3">
      {proofs.map((proof) => (
        <CCol xs={12} sm={6} md={4} lg={3} key={proof.id}>
          <CCard className="h-100 shadow-sm border-0 overflow-hidden">
            <div
              className="bg-black"
              style={{ height: "200px", cursor: "pointer", overflow: "hidden" }}
              onClick={() =>
                onPhotoClick({
                  url: proof.photo_url,
                  title: `${proof.truck_name} — ${dayjs(proof.end_time).format("DD.MM.YY HH:mm")}`,
                })
              }
              aria-hidden="true"
            >
              <img
                src={proof.photo_url}
                alt={i18n.t('proof_gallery.loading', 'Загрузка')}
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  transition: "transform 0.2s",
                }}
                onMouseEnter={(e) => {
                  e.target.style.transform = "scale(1.05)";
                }}
                onMouseLeave={(e) => {
                  e.target.style.transform = "scale(1)";
                }}
              />
            </div>
            <CCardBody className="p-3">
              <div className="d-flex justify-content-between align-items-center mb-2">
                <span className="text-muted small fw-bold">
                  <CIcon icon={cilCalendar} className="me-1" />
                  {dayjs(proof.end_time).format("DD.MM.YY HH:mm")}
                </span>
                <span className="badge bg-success">
                  {Number(proof.volume).toFixed(2)} м³
                </span>
              </div>
              <div
                className="fw-bold text-dark text-truncate"
                title={proof.truck_name}
              >
                {proof.truck_name}
              </div>
              <div
                className="text-muted small text-truncate"
                title={proof.device_name}
              >
                {i18n.t('proof_gallery.loader', 'Погрузчик:')} {proof.device_name}
              </div>
              <div className="text-muted small">
                {i18n.t('proof_gallery.buckets', 'Ковшей:')} <strong>{proof.cycles}</strong>
              </div>
            </CCardBody>
          </CCard>
        </CCol>
      ))}
    </CRow>
  );
};

ProofGallery.propTypes = {
  proofs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      photo_url: PropTypes.string,
      end_time: PropTypes.string,
      truck_name: PropTypes.string,
      volume: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      device_name: PropTypes.string,
      cycles: PropTypes.number,
    }),
  ).isRequired,
  loading: PropTypes.bool.isRequired,
  onPhotoClick: PropTypes.func.isRequired,
};

export default ProofGallery;